import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsMendeleyComponent } from './simple-icons-mendeley.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsMendeleyComponent ],
    exports:      [ SimpleIconsMendeleyComponent ],
    bootstrap:    []
})
export class SimpleIconsMendeleyModule {}
